// function SampleNextArrow(props: any) {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={`${className} vNext`}
//       style={{ ...style, display: 'block' }}
//       onClick={onClick}
//     ></div>
//   );
// }

// function SamplePrevArrow(props: any) {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={`${className} vPrev`}
//       style={{ ...style, display: 'block' }}
//       onClick={onClick}
//     />
//   );
// }

// export const videoSettings = {
//   dots: false,
//   customPaging: (i: number) => (
//     <div
//       style={{
//         position: 'absolute',
//         width: '100%',
//         top: '-6px',
//         opacity: '0',
//       }}
//     >
//       {i + 1}
//     </div>
//   ),
//   dotsClass: 'prizes-dots',
//   infinite: true,
//   speed: 1000,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   initialSlide: 3,
//   arrows: true,
//   autoplay: true,
//   nextArrow: <SampleNextArrow />,
//   prevArrow: <SamplePrevArrow />,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true,
//       },
//     },
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         initialSlide: 0,
//       },
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         initialSlide: 2,
//       },
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//       },
//     },
//   ],
// };

function SampleNextArrow(props: any) {
  const { className, onClick } = props;
  return (
    <div
      className={`${className} tNext d-block`}
      // style={{ ...style, display: 'block', marginTop: '5%' }}
      onClick={onClick}
    ></div>
  );
}

function SamplePrevArrow(props: any) {
  const { className, onClick } = props;
  return (
    <div
      className={`${className} tPrev d-block`}
      // style={{ ...style, display: 'block', marginTop: '5%' }}
      onClick={onClick}
    />
  );
}

export const VideoSettings = {
  dots: false,
  customPaging: (i: number) => (
    <div
      // style={{
      //   position: 'absolute',
      //   width: '100%',
      //   top: '-6px',
      //   opacity: '0',
      // }}
      className="dg_testimonial-settings"
    >
      {i + 1}
    </div>
  ),
  dotsClass: 'prizes-dots',
  infinite: true,
  speed: 1000,
  slidesToShow: 3.1,
  slidesToScroll: 1,
  initialSlide: 0,
  arrows: true,
  autoplay: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
      },
    },
  ],
};
